import angular from 'angular';

module.exports = angular.module('common.filters.tel', [])
.filter('tel', function () {
  return function(value, dotDelimiter=false) {
    if (!value) return '';

    var numbers = value.toString().trim().replace(/\D/g, '')
      , parts = [];

    if (numbers[0] === '1')
      numbers = numbers.slice(1);

    if (numbers.length === 0)
      return '';

    parts.push(numbers.slice(0, 3));

    if (numbers.length >= 4) {
      if (dotDelimiter) {
        parts.push('.');
      } else {
        parts.unshift('(');
        parts.push(')');
        parts.push(' ');
      }
      parts.push(numbers.slice(3, 6));

      if (numbers.length >= 7) {
        if (dotDelimiter) {
          parts.push('.');
        } else {
          parts.push('-');
        }
        parts.push(numbers.slice(6, 10));
      }
    }

    return parts.join('');
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/tel.js
 **/